module.exports = __webpack_public_path__ + "static/img/banner2-3.62d7113.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner2-3.jpg
// module id = BV5r
// module chunks = 1